// tslint:disable
// @ts-nocheck
/**
 * Enter API Documentation
 * ## Interactive Documentation ##### Our API documentation allows you to test API calls straight from this website. ##### To do this, scroll down a little and click the green \"Authorize\" button (with a padlock) to the right and below. A pop-up should appear. ##### In the popup, enter your \"client_id\" and \"client_secret\" values (these will be provided to you) and press \"Authorize\". You should now be logged in (you can open up your network tab to see the API traffic going through). ##### From here, you can click any endpoint below to expand its details and click the \"Try it out\" button that appears in the expanded section. ##### Fill out the parameter fields and then click \"Execute\" to call the endpoint. The results of your query should be shown below. ## Authentication ##### Our API uses the OAuth 2.0 Client Credentials flow to authorize clients. ##### With your provided \"Client Id\" and \"Client Secret\", make the following call: ``` POST /oauth/token HTTP/1.1 Host: api.enter.health  grant_type=client_credentials &client_id=XXXXXXXXXXXX &client_secret=YYYYYYYYYYY ``` ##### Here\'s an example CURL request: ``` curl \'https://api.enter.health/oauth/token\' -H \'accept: application/json\' --data \'grant_type=client_credentials&client_id=XXXXXXXXXXXX&client_secret=YYYYYYYYYYY\' ``` ##### The response should look something like this ``` {   \"access_token\" : \"AAAAAAAAAAAAAAAAAAA\",   \"refresh_token\" : \"BBBBBBBBBBBBBBBBBBB\" }  ``` ##### With the access token provided, you can make an authenticated call to any of the endpoints below by including the header \"Authorization: Bearer AAAAAAAAAAAAAAAAAAA\" with your API request. ##### Here\'s an example of a basic curl request to the \"/me\" endpoint ``` curl \'https://api.enter.health/me\' -H \'accept: application/json\' -H \'authorization: Bearer AAAAAAAAAAAAAAAAAAA\' ``` ##### Note that access tokens are not long-living tokens. The lifetime of them differs from client to client, but they may last as short as 15 minutes (if you would like an increase in time, please reach out to us). ### Comparators ##### Filter parameters need to be formatted with a comparator and value in the format of \"COMPARATOR:VALUE\". The following is a list of possible values:  ##### GTE - Greater than or equal ##### GT - Greater than ##### LT - Less Than ##### LTE - Less than or equal ##### EQ - Equal ##### NQ - Not Equal ##### LK - Like ##### NLK - Not Like ##### EMPTY - Is null ##### NEMPTY - Is not null ## Subject to Change ##### Note that this API is in active development and may be subject to changes at any time. ##### This document is a living document with current specifications. If your integration does not seem to work properly, please refer back to this page to look for updates. ##### If you are still having issues, please reach out to support. 
 *
 * The version of the OpenAPI document: 2
 * Contact: support@enter.health
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists } from '../runtime';
/**
 * 
 * @export
 * @interface SupportCreateDocumentAppealPayloadAppealForm
 */
export interface SupportCreateDocumentAppealPayloadAppealForm {
    /**
     * 
     * OpenAPI data type: {string}
     * @type {Date}
     * @memberof SupportCreateDocumentAppealPayloadAppealForm
     */
    date?: string;
    /**
     * Member id number
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof SupportCreateDocumentAppealPayloadAppealForm
     */
    memberId?: string;
    /**
     * 
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof SupportCreateDocumentAppealPayloadAppealForm
     */
    planType?: SupportCreateDocumentAppealPayloadAppealFormPlanTypeEnum;
    /**
     * Member group number
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof SupportCreateDocumentAppealPayloadAppealForm
     */
    memberGroupId?: string;
    /**
     * Member first name
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof SupportCreateDocumentAppealPayloadAppealForm
     */
    memberFirst?: string;
    /**
     * Member last name
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof SupportCreateDocumentAppealPayloadAppealForm
     */
    memberLast?: string;
    /**
     * Member birthdate
     * OpenAPI data type: {string}
     * @type {Date}
     * @memberof SupportCreateDocumentAppealPayloadAppealForm
     */
    memberDob?: string;
    /**
     * The billing provider name
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof SupportCreateDocumentAppealPayloadAppealForm
     */
    providerName?: string;
    /**
     * The billing provider NPI
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof SupportCreateDocumentAppealPayloadAppealForm
     */
    providerNpi?: string;
    /**
     * The billing provider EIN
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof SupportCreateDocumentAppealPayloadAppealForm
     */
    providerTin?: string;
    /**
     * The billing provider medicare number
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof SupportCreateDocumentAppealPayloadAppealForm
     */
    providerPtan?: string;
    /**
     * The payer name
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof SupportCreateDocumentAppealPayloadAppealForm
     */
    payerName?: string;
    /**
     * The payer ICN or claim id
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof SupportCreateDocumentAppealPayloadAppealForm
     */
    payerClaimId?: string;
    /**
     * The payer reference or prior authorization number
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof SupportCreateDocumentAppealPayloadAppealForm
     */
    payerReferenceNumber?: string;
    /**
     * The date of service from
     * OpenAPI data type: {string}
     * @type {Date}
     * @memberof SupportCreateDocumentAppealPayloadAppealForm
     */
    payerDosFrom?: string;
    /**
     * The date of service to
     * OpenAPI data type: {string}
     * @type {Date}
     * @memberof SupportCreateDocumentAppealPayloadAppealForm
     */
    payerDosTo?: string;
    /**
     * The initial denial dates from the payer
     * OpenAPI data type: {array}
     * @type {Array<Date>}
     * @memberof SupportCreateDocumentAppealPayloadAppealForm
     */
    payerInitialDenialDates?: Array<string>;
    /**
     * The reconsideration denial dates from the payer
     * OpenAPI data type: {array}
     * @type {Array<Date>}
     * @memberof SupportCreateDocumentAppealPayloadAppealForm
     */
    payerReconsiderationDenialDates?: Array<string>;
    /**
     * The reconsideration denial procedure codes from the payer
     * OpenAPI data type: {array}
     * @type {Array<string>}
     * @memberof SupportCreateDocumentAppealPayloadAppealForm
     */
    payerDisputedProcedureCodes?: Array<string>;
    /**
     * The explanation of the appeal request
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof SupportCreateDocumentAppealPayloadAppealForm
     */
    payerExplanationOfRequest?: string;
}

export function SupportCreateDocumentAppealPayloadAppealFormFromJSON(json: any): SupportCreateDocumentAppealPayloadAppealForm {
    return {
            'date': !exists(json, 'date') ? undefined : json['date'],
            'memberId': !exists(json, 'memberId') ? undefined : json['memberId'],
            'planType': !exists(json, 'planType') ? undefined : json['planType'],
            'memberGroupId': !exists(json, 'memberGroupId') ? undefined : json['memberGroupId'],
            'memberFirst': !exists(json, 'memberFirst') ? undefined : json['memberFirst'],
            'memberLast': !exists(json, 'memberLast') ? undefined : json['memberLast'],
            'memberDob': !exists(json, 'memberDob') ? undefined : json['memberDob'],
            'providerName': !exists(json, 'providerName') ? undefined : json['providerName'],
            'providerNpi': !exists(json, 'providerNpi') ? undefined : json['providerNpi'],
            'providerTin': !exists(json, 'providerTin') ? undefined : json['providerTin'],
            'providerPtan': !exists(json, 'providerPtan') ? undefined : json['providerPtan'],
            'payerName': !exists(json, 'payerName') ? undefined : json['payerName'],
            'payerClaimId': !exists(json, 'payerClaimId') ? undefined : json['payerClaimId'],
            'payerReferenceNumber': !exists(json, 'payerReferenceNumber') ? undefined : json['payerReferenceNumber'],
            'payerDosFrom': !exists(json, 'payerDosFrom') ? undefined : json['payerDosFrom'],
            'payerDosTo': !exists(json, 'payerDosTo') ? undefined : json['payerDosTo'],
            'payerInitialDenialDates': !exists(json, 'payerInitialDenialDates') ? undefined : json['payerInitialDenialDates'],
            'payerReconsiderationDenialDates': !exists(json, 'payerReconsiderationDenialDates') ? undefined : json['payerReconsiderationDenialDates'],
            'payerDisputedProcedureCodes': !exists(json, 'payerDisputedProcedureCodes') ? undefined : json['payerDisputedProcedureCodes'],
            'payerExplanationOfRequest': !exists(json, 'payerExplanationOfRequest') ? undefined : json['payerExplanationOfRequest'],
    };

}

export function SupportCreateDocumentAppealPayloadAppealFormToForm(value?: SupportCreateDocumentAppealPayloadAppealForm): any {
    let jsonVal = SupportCreateDocumentAppealPayloadAppealFormToJSON(value);
    let retVal = '';
    if(jsonVal !== undefined && jsonVal != null) {
        Object.keys(jsonVal).forEach((v, i) => {
            if(i > 0) retVal+= "&";
            retVal+= encodeURIComponent(v) + "=" + encodeURIComponent(jsonVal[v]);
        });
    }
    return retVal;
}

function cleanupBlankValuesForBackend(val?:any): any {
    if(val instanceof Array) {
        return (val as Array<any>).filter((val) => { return val !== undefined && val !== null && val !== ''});
    } else {
        return (val === '') ? null : val;
    }
}

export function SupportCreateDocumentAppealPayloadAppealFormToJSON(value?: SupportCreateDocumentAppealPayloadAppealForm): any {
    value = cleanupBlankValuesForBackend(value);
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
            'date': cleanupBlankValuesForBackend(value.date),
            'memberId': cleanupBlankValuesForBackend(value.memberId),
            'planType': cleanupBlankValuesForBackend(value.planType),
            'memberGroupId': cleanupBlankValuesForBackend(value.memberGroupId),
            'memberFirst': cleanupBlankValuesForBackend(value.memberFirst),
            'memberLast': cleanupBlankValuesForBackend(value.memberLast),
            'memberDob': cleanupBlankValuesForBackend(value.memberDob),
            'providerName': cleanupBlankValuesForBackend(value.providerName),
            'providerNpi': cleanupBlankValuesForBackend(value.providerNpi),
            'providerTin': cleanupBlankValuesForBackend(value.providerTin),
            'providerPtan': cleanupBlankValuesForBackend(value.providerPtan),
            'payerName': cleanupBlankValuesForBackend(value.payerName),
            'payerClaimId': cleanupBlankValuesForBackend(value.payerClaimId),
            'payerReferenceNumber': cleanupBlankValuesForBackend(value.payerReferenceNumber),
            'payerDosFrom': cleanupBlankValuesForBackend(value.payerDosFrom),
            'payerDosTo': cleanupBlankValuesForBackend(value.payerDosTo),
            'payerInitialDenialDates': cleanupBlankValuesForBackend(value.payerInitialDenialDates),
            'payerReconsiderationDenialDates': cleanupBlankValuesForBackend(value.payerReconsiderationDenialDates),
            'payerDisputedProcedureCodes': cleanupBlankValuesForBackend(value.payerDisputedProcedureCodes),
            'payerExplanationOfRequest': cleanupBlankValuesForBackend(value.payerExplanationOfRequest),
    };
}

/**
* @export
* @enum {string}
*/
export enum SupportCreateDocumentAppealPayloadAppealFormPlanTypeEnum {
    MEDICAL = 'MEDICAL',
    DENTAL = 'DENTAL'
}


